import { render, staticRenderFns } from "./BuyerResetCapCountersModal.vue?vue&type=template&id=3b97721c"
import script from "./BuyerResetCapCountersModal.vue?vue&type=script&lang=js"
export * from "./BuyerResetCapCountersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports